import {
  TextOperation,
  ITextProcessorMiddleware,
} from 'components/RichTextEditor/processor/constants'
import { isRangesIntersected, createRange } from 'components/RichTextEditor/processor/range'
import { getSlices } from 'components/RichTextEditor/processor/selectors/textProcessorSelectors'

interface IActionFilter {
  (action: TextOperation): boolean
}

export const createDeleteBlockMiddleware =
  (sliceType: string, actionFilter: IActionFilter = () => true): ITextProcessorMiddleware =>
  (api) =>
  (next) =>
  (action) => {
    if (!action || action.type !== 'delete' || !actionFilter(action)) {
      return next(action)
    }
    const { start, length } = action
    const deleteRange = createRange(start, length)
    const slices = getSlices(api.getState()).filter((slice) => slice.type === sliceType)
    const blockToDelete = slices.find((s) => isRangesIntersected(s.range, deleteRange))
    if (blockToDelete) {
      action.start = Math.min(start, blockToDelete.range.start)
      const actionEnd = Math.max(start + length, blockToDelete.range.end)
      action.length = actionEnd - action.start
    }
    return next(action)
  }
